import * as React from "react";
type Props = {
  className?: string,
};
function SvgSupplements({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-supplements"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 7.25C19 8.49264 17.9926 9.5 16.75 9.5C15.5074 9.5 14.5 8.49264 14.5 7.25C14.5 6.00736 15.5074 5 16.75 5C17.9926 5 19 6.00736 19 7.25ZM21 7.25C21 9.59721 19.0972 11.5 16.75 11.5C14.4028 11.5 12.5 9.59721 12.5 7.25C12.5 4.90279 14.4028 3 16.75 3C19.0972 3 21 4.90279 21 7.25ZM5.73223 10.4922C4.75592 11.4685 4.75592 13.0515 5.73223 14.0278L7.35223 15.6478L10.8878 12.1122L9.26777 10.4922C8.29146 9.51592 6.70854 9.51592 5.73223 10.4922ZM9.97487 18.2704L8.76645 17.062L12.302 13.5264L13.5104 14.7349C14.4867 15.7112 14.4867 17.2941 13.5104 18.2704C12.5341 19.2467 10.9512 19.2467 9.97487 18.2704ZM4.31802 9.07801C2.56066 10.8354 2.56066 13.6846 4.31802 15.442L8.56066 19.6846C10.318 21.442 13.1673 21.442 14.9246 19.6846C16.682 17.9273 16.682 15.078 14.9246 13.3207L10.682 9.07801C8.92462 7.32065 6.07538 7.32065 4.31802 9.07801Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgSupplements;
